export default __webpack_public_path__ + "static/beekeeper-bee-cb538ee4f7219ec92293c32137ad73a7.png";